import { useState, useMemo, useEffect } from 'react';
import queryString from 'query-string';

const FORMAT = 'bracket'; // 'bracket', 'index' or 'none' ... If v6 (no IE11 support, can also use 'comma' or 'separator')
const options = {
  arrayFormat: FORMAT,
};

export default function useQueryString({
  store: initialStore = 'hash',
  initialFilters = {},
}) {
  const [store, setStore] = useState(initialStore);
  const initialState = useMemo(() => {
    const parsedFilters = queryString.parse(
      location[initialStore].substr(1),
      options
    );

    return Object.keys(parsedFilters).length ? parsedFilters : initialFilters;
  }, []);

  const [str, setStr] = useState(queryString.stringify(initialState, options));
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (str !== false) {
      if (str === '') {
        history.pushState(null, null, ' ');
      } else {
        location[store] = str;
      }
      const nextState = queryString.parse(location[store].substr(1), options);
      setState(nextState);
    }
  }, [str]);

  const set = (filter, value = null, method = 'set') => {
    let nextValue = value;
    switch (method) {
      case 'toggle':
        nextValue = state[filter]
          ? state[filter].includes(value)
            ? state[filter].filter((v) => v !== value)
            : state[filter].concat(value)
          : [value];
        break;
      case 'set':
        nextValue = value;
        break;
    }
    const nextState = {
      ...state,
      [filter]: nextValue,
    };

    // Delete empty keys before stringifying
    Object.keys(nextState).forEach((key) => {
      if (!nextState[key]) {
        delete nextState[key];
      }
    });

    const str = queryString.stringify(nextState, options);
    setStr(str);
  };

  const obj = {
    ...state,
  };

  const api = set;

  return [obj, api];
}
